import {
  BasketCustomerDetails,
  CLPAddQuoteToBasketResponse,
} from '@domgen/dgx-fe-basket';

export interface CreateBasketItemOrAddCLPQuoteToBasketResponse
  extends CLPAddQuoteToBasketResponse {
  customer?: BasketCustomerDetails;
  requestedItemId?: string;
}
